/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Normalized_Power_RangeInputs */

const en_exp_normalized_power_range = /** @type {(inputs: Exp_Normalized_Power_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Compare to your FTP. NP close to FTP means a threshold-level effort. NP at 75% of FTP is endurance pace. Above FTP for a sustained ride is very hard.`)
};

const de_exp_normalized_power_range = /** @type {(inputs: Exp_Normalized_Power_RangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergleich mit deiner FTP: NP nahe FTP = Schwellenbelastung. NP bei 75% FTP = Ausdauertempo. Über FTP auf einer langen Fahrt = sehr hart.`)
};

/**
* | output |
* | --- |
* | "Compare to your FTP. NP close to FTP means a threshold-level effort. NP at 75% of FTP is endurance pace. Above FTP for a sustained ride is very hard." |
*
* @param {Exp_Normalized_Power_RangeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const exp_normalized_power_range = /** @type {((inputs?: Exp_Normalized_Power_RangeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Normalized_Power_RangeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_exp_normalized_power_range(inputs)
	return de_exp_normalized_power_range(inputs)
});